module.exports = __webpack_public_path__ + "img/1.d9459c04.jpg";